// import _ from 'lodash';
// import Vue from 'vue'

let me = {
    api: null,
    pc: 0,
    maxVisitedPageIndex: 0
}

me.setClientAPI = (c) =>  {
    if (me.api && me.api.schema) return
    me.api = c;

    window.document.title = window.api.schema.elements.name;

    me.api.eventSubscribe("backbutton_popstate", 'popstate', () => {
        window.console.log('backbutton_popstate called')
        me.api.setCurrentPage(window.history.state || 0)
    });

}

export default me